var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDays2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zycfsomd6a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#byymw47cub)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.938 3.47c-.825.097-1.43.286-1.931.65-.336.245-.632.54-.876.876-.756 1.04-.756 2.525-.756 5.494 0 2.968 0 4.452.756 5.493.244.336.54.631.876.876 1.04.756 2.524.756 5.493.756.664 0 1.254 0 1.781-.009v-.055c0-.675 0-1.086.056-1.44a4.552 4.552 0 0 1 3.784-3.784c.355-.056.765-.056 1.44-.056h.055c.009-.527.009-1.117.009-1.781 0-2.969 0-4.453-.756-5.494a3.956 3.956 0 0 0-.876-.875c-.501-.365-1.106-.554-1.93-.651v.686a1.188 1.188 0 0 1-2.376 0v-.79L9.5 3.366c-.425 0-.82 0-1.188.002v.79a1.187 1.187 0 1 1-2.374 0V3.47z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.573 13.458c-.72 0-1.022.003-1.266.042a3.364 3.364 0 0 0-2.797 2.797c-.038.244-.041.545-.041 1.266 1.14-.075 1.91-.258 2.524-.704.336-.245.632-.54.876-.876.447-.615.63-1.385.704-2.525zM7.719 1.781a.594.594 0 1 0-1.188 0v2.375a.594.594 0 1 0 1.188 0V1.781zM12.469 1.781a.594.594 0 0 0-1.188 0v2.375a.594.594 0 0 0 1.188 0V1.781z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.031 2.955-.152.018c-.87.103-1.569.309-2.166.743a4.458 4.458 0 0 0-.987.986c-.45.62-.654 1.35-.754 2.264-.097.9-.097 2.035-.097 3.493v.061c0 1.459 0 2.594.097 3.493.1.915.304 1.644.754 2.264.275.378.608.711.987.986.62.45 1.349.655 2.263.754.9.098 2.035.098 3.493.098h.033c.662 0 1.256 0 1.787-.009l.492-.008v-.547c0-.69.002-1.055.05-1.362a4.052 4.052 0 0 1 3.368-3.368c.307-.049.671-.05 1.362-.05h.548l.007-.492c.009-.531.009-1.124.009-1.786v-.033c0-1.459 0-2.595-.097-3.494-.1-.915-.304-1.644-.755-2.264a4.458 4.458 0 0 0-.986-.986c-.597-.434-1.296-.64-2.166-.743l-.152-.018V1.781a1.094 1.094 0 0 0-2.188 0v1.086h-.09c-.37-.002-.765-.002-1.19-.002H9.5c-.425 0-.82 0-1.19.002h-.09V1.781a1.094 1.094 0 0 0-2.188 0v1.174zm11.041 10.536.035-.533h-.534c-.702 0-1.052.002-1.344.048a3.865 3.865 0 0 0-3.213 3.212c-.046.293-.047.642-.047 1.345v.534l.533-.035c1.167-.077 2.054-.267 2.785-.799.379-.275.711-.608.986-.986.532-.732.723-1.619.8-2.786z",
    stroke: "url(#oqzylp2psc)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#u6jp9s7rtd)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.542 8.115a.792.792 0 1 0 0-1.584.792.792 0 0 0 0 1.584zM6.333 10.49a.792.792 0 1 1-1.583 0 .792.792 0 0 1 1.583 0zM9.5 8.115a.792.792 0 1 0 0-1.584.792.792 0 0 0 0 1.584zM10.292 10.49a.792.792 0 1 1-1.584 0 .792.792 0 0 1 1.584 0zM9.5 14.448a.792.792 0 1 0 0-1.583.792.792 0 0 0 0 1.583zM14.25 7.323a.792.792 0 1 1-1.583 0 .792.792 0 0 1 1.583 0zM13.458 11.281a.792.792 0 1 0 0-1.583.792.792 0 0 0 0 1.583zM6.333 13.656a.792.792 0 1 1-1.583 0 .792.792 0 0 1 1.583 0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "byymw47cub",
    x: -22.625,
    y: -23.813,
    width: 64.266,
    height: 66.443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_400_1618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_400_1618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u6jp9s7rtd",
    x: 1.75,
    y: 3.531,
    width: 25.5,
    height: 23.916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_400_1618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_400_1618",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oqzylp2psc",
    x1: 2.375,
    y1: 1.188,
    x2: 18.643,
    y2: 15.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zycfsomd6a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19v19H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDays2);
export default __webpack_public_path__ + "static/media/Days2.e9b4f391d55ad4ec0cba2b20158f220d.svg";
export { ForwardRef as ReactComponent };